import { Circle } from '@mui/icons-material';
import { Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { EstateStatus } from 'queries';

import { EstateStatusExternalLabel } from 'utils/estate';

type Props = {
  estateStatus: EstateStatus;
  onClick?: Function;
};

const useStyles = makeStyles(() => ({
  status: {
    padding: '8px',
    gap: '6px',
    display: 'flex',
    height: '24px',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    borderRadius: '100px',
  },
  statusChipGreen: {
    color: '#000000',
    backgroundColor: '#03C04A',
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '13px',
  },
  statusChipBlack: {
    color: '#1C2541',
    backgroundColor: '#F9F9FB',
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '13px',
  },
  statusChipPurple: {
    color: '#5925DC',
    backgroundColor: '#F4F3FF',
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '13px',
  },
  statusChipYellow: {
    color: '#BE5C23',
    backgroundColor: '#FFFAEB',
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '13px',
  },
  statusChipRed: {
    color: '#B42318',
    backgroundColor: '#FEF3F2',
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '13px',
  },
  statusChipBlue: {
    color: '#175CD3',
    backgroundColor: '#EFF8FF',
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '13px',
  },
}));

const sx = {
  statusChipGreenDot: { '&&': { color: '#0FA65F', width: '6px', height: '6px' } },
  statusChipBlackDot: { '&&': { color: '#434E59', width: '6px', height: '6px' } },
  statusChipPurpleDot: { '&&': { color: '#7A5AF8', width: '6px', height: '6px' } },
  statusChipYellowDot: { '&&': { color: '#F79009', width: '6px', height: '6px' } },
  statusChipRedDot: { '&&': { color: '#F04438', width: '6px', height: '6px' } },
  statusChipBlueDot: { '&&': { color: '#2E90FA', width: '6px', height: '6px' } },
};

const AssignedTrusuiteSearchTaskStatus = ({ estateStatus, onClick }: Props) => {
  const classes = useStyles();

  const status = EstateStatusExternalLabel[estateStatus];
  if (!status) {
    return <></>;
  }

  const getClassNames = (statusLabel: string) => {
    const statusChipGreen: string[] = [
      EstateStatusExternalLabel.RESULTS_READY,
      EstateStatusExternalLabel.COMPLETED,
      EstateStatusExternalLabel.ARCHIVED,
      EstateStatusExternalLabel.RESULTS_EXPIRED,
    ];

    const statusChipBlack: string[] = [
      EstateStatusExternalLabel.DETAIL_ENTRY,
      EstateStatusExternalLabel.DOCUMENT_UPLOAD,
      EstateStatusExternalLabel.PAYMENT,
    ];

    const statusChipPurple: string[] = [
      EstateStatusExternalLabel.TRUSTATE_APPROVAL,
      EstateStatusExternalLabel.CLIENT_CONSENT,
      EstateStatusExternalLabel.CLIENT_CONSENT_EMAIL_SENT,
      EstateStatusExternalLabel.SEARCH_IN_PROCESS,
    ];

    const statusChipYellow: string[] = [];

    const statusChipRed: string[] = [];

    const statusChipBlue: string[] = [];

    if (statusChipGreen.includes(statusLabel)) {
      return [classes.statusChipGreen, sx.statusChipGreenDot];
    } else if (statusChipBlack.includes(statusLabel)) {
      return [classes.statusChipBlack, sx.statusChipBlackDot];
    } else if (statusChipPurple.includes(statusLabel)) {
      return [classes.statusChipPurple, sx.statusChipPurpleDot];
    } else if (statusChipYellow.includes(statusLabel)) {
      return [classes.statusChipYellow, sx.statusChipYellowDot];
    } else if (statusChipRed.includes(statusLabel)) {
      return [classes.statusChipRed, sx.statusChipRedDot];
    } else if (statusChipBlue.includes(statusLabel)) {
      return [classes.statusChipBlue, sx.statusChipBlueDot];
    } else {
      return [classes.statusChipBlack, sx.statusChipBlackDot];
    }
  };

  const [textClass, dotClass] = getClassNames(EstateStatusExternalLabel[estateStatus]);

  return (
    <Chip
      className={textClass as string}
      icon={
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        <Circle sx={dotClass as any} />
      }
      label={`${EstateStatusExternalLabel[estateStatus]}`}
      size="small"
      onClick={() => {
        onClick && onClick();
      }}
    />
  );
};

export default AssignedTrusuiteSearchTaskStatus;
